import axios from 'axios';
import { message } from 'antd';
import { useAuth } from './auth';
import { mockApiResponse } from './mockApi';

export const api = axios.create({ baseURL: import.meta.env.VITE_API_URL || 'http://localhost:4000/api', timeout: 60000 });

api.interceptors.request.use((config) => {
  const token = useAuth.getState().token;
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

api.interceptors.response.use(
  (response) => response,
  (error) => {
    const status = error.response?.status;
    if (!error.response && error.config) {
      try {
        const data = mockApiResponse(error.config);
        if (!sessionStorage.getItem('pgas-demo-notice')) {
          sessionStorage.setItem('pgas-demo-notice', 'shown');
          void message.warning('后端暂不可用，已自动进入本地演示模式');
        }
        return Promise.resolve({ data, status: 200, statusText: 'DEMO', headers: {}, config: error.config });
      } catch (mockError) {
        void message.error(mockError instanceof Error ? mockError.message : '演示模式请求失败');
        return Promise.reject(mockError);
      }
    }
    if (status === 401) {
      useAuth.getState().logout();
      if (location.pathname !== '/login') location.href = '/login';
    } else if (status !== 404) {
      const value = error.response?.data?.message;
      void message.error(Array.isArray(value) ? value.join('；') : value || '操作失败，请稍后重试');
    }
    return Promise.reject(error);
  },
);
